module.exports = __webpack_public_path__ + "img/ad_3.a69aff85.png";